"use client"

import React from 'react';
import {useAppStore} from "@/store/AppStore";
import {TreeItem} from "@mui/x-tree-view/TreeItem";
import {CircularProgress} from "@mui/material";
import {Liturgy} from "@/types/Liturgies";
import useSaintsData from "@/utils/hooks/useSaintsData";

export default function SaintsItems() {

  const user = useAppStore((state) => state.user);
  const data = useSaintsData(user?.access_token)

  const items = data?.items

  if (!user) return null
  if (!data) return <CircularProgress/>

  return (
    <>
      {items && items.map((itm: Liturgy, key: number) => {
        return <TreeItem key={key} label={itm.name} itemId={`saint-${itm.id}`}/>
      })
      }
    </>
  )
}
